import { createContext, useContext } from "react";

export interface ZoomState {
    zoomLevel: number;
    isLocked: boolean;
    x: number;
    y: number;
}

export interface ZoomContextType {
    zoomLevel: number;
    isLocked: boolean;
    x: number;
    y: number;
    zoomIn: () => void;
    zoomOut: () => void;
    resetZoom: () => void;
    setZoom: (zoom: number, x?: number, y?: number) => void;
    toggleLock: () => void;
    setPosition: (x: number, y: number) => void;
    pan: (deltaX: number, deltaY: number) => void;
}

export const ZoomContext = createContext<ZoomContextType | undefined>(undefined);

export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 5.0;
export const DEFAULT_ZOOM = 1.0;

export const useZoom = (): ZoomContextType => {
    const context = useContext(ZoomContext);
    if (!context) {
        throw new Error("useZoom must be used within a ZoomProvider");
    }
    return context;
};
